module.exports = __webpack_public_path__ + "static/media/flooring-orders.1ed2d325.png";